export const MEDIA_MONITORING_META_DESCRIPTION =
  "Perceptica's media monitoring services cover print, online, broadcast and social across Southeast Europe - daily monitoring, alerts and analyst review.";
